import Header from "@/components/navigation/Header";
import TabMenu from "@/components/navigation/TabMenu";
import { DashboardParamsProviders } from "@/context/DashboardParamsProviders";
import { Outlet, useLocation } from "react-router";

const Dashboard = () => {
  const entity = useLocation().pathname.split("/")[2];

  const content = (
    <>
      <Header />
      <TabMenu>
        <Outlet />
      </TabMenu>
    </>
  );

  return entity ? (
    <DashboardParamsProviders key={entity} storageKey={entity}>
      {content}
    </DashboardParamsProviders>
  ) : (
    content
  );
};

export default Dashboard;
